function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkflowBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.55556 3.5H3.44444C3.19898 3.5 3 3.69898 3 3.94444V7.05556C3 7.30102 3.19898 7.5 3.44444 7.5H6.55556C6.80102 7.5 7 7.30102 7 7.05556V3.94444C7 3.69898 6.80102 3.5 6.55556 3.5Z",
    stroke: "#28245C",
    style: {
      stroke: "#28245C",
      stroke: "color(display-p3 0.1569 0.1412 0.3608)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5556 17.5H17.4444C17.199 17.5 17 17.699 17 17.9444V21.0556C17 21.301 17.199 21.5 17.4444 21.5H20.5556C20.801 21.5 21 21.301 21 21.0556V17.9444C21 17.699 20.801 17.5 20.5556 17.5Z",
    stroke: "#28245C",
    style: {
      stroke: "#28245C",
      stroke: "color(display-p3 0.1569 0.1412 0.3608)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 19.5H7C5.89543 19.5 5 18.6046 5 17.5V16.5V14.5C5 13.3954 5.89543 12.5 7 12.5H17C18.1046 12.5 19 11.6046 19 10.5V7.5C19 6.39543 18.1046 5.5 17 5.5H8",
    stroke: "#28245C",
    style: {
      stroke: "#28245C",
      stroke: "color(display-p3 0.1569 0.1412 0.3608)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowBlue);
export default __webpack_public_path__ + "static/media/workflow-blue.d577b86780388b39b1fc1283e08e24c3.svg";
export { ForwardRef as ReactComponent };